/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */
export const swiperObserver = (swiperInstance) => {
  if (!swiperInstance?.el) {
    return null;
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.85,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const autoplay = swiperInstance.autoplay;

      if (
        swiperInstance.destroyed ||
        typeof autoplay?.start !== 'function' ||
        typeof autoplay?.stop !== 'function'
      ) {
        observer.disconnect();
        return;
      }

      if (entry.isIntersecting) {
        const focusRegion = swiperInstance.el.closest('[class*="swiper-wr"]') || swiperInstance.el;
        if (!focusRegion.contains(document.activeElement)) autoplay.start();
      } else {
        autoplay.stop();
      }
    });
  }, observerOptions);

  observer.observe(swiperInstance.el);

  return observer;
};
